import { render, staticRenderFns } from "./questionDetail.vue?vue&type=template&id=e188c184&scoped=true&"
import script from "./questionDetail.vue?vue&type=script&lang=ts&"
export * from "./questionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./questionDetail.vue?vue&type=style&index=0&id=e188c184&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e188c184",
  null
  
)

export default component.exports